<template>
  <div class="dialog-body">
    <el-dialog
      title="项目转合同确认"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
      center=""
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block">请选择要转换为的合同类型</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-form
            :model="dialogData"
            ref="dialogForm"
            label-width="100px"
            style="margin-top: 20px"
            :rules="rules"
          >
            <el-form-item label="合同类型" prop="type">
              <el-select
                v-model="dialogData.type"
                placeholder="请选择"
                label=""
                style="width: 100%"
              >
                <template v-if="serviceTypeCode == 'CC'">
                  <el-option
                    v-for="(item, index) in typeCC"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  >
                  </el-option>
                </template>
                <template v-else-if="serviceTypeCode == 'JG'">
                  <el-option
                    v-for="(item, index) in typeJG"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  >
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleSure">生成合同</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="提醒" :visible.sync="centerDialogVisible" width="30%" center>
      <span class="center">由于此项目下面已关联合同，</span>
      <span class="center">若需要修改项目，则需要停用此项目下的合同</span>
    </el-dialog> -->
  </div>
</template>

<script>
  export default {
    name: 'ProjectToContractDialog',
    data() {
      return {
        dialogVisible: false,
        // centerDialogVisible: false,
        typeCC: [{ label: '仓储合同', value: 'CC' }],
        typeJG: [{ label: '监管合同', value: 'JG' }],
        dialogData: { type: null },
        rules: {
          type: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        },
      };
    },
    props: ['serviceTypeCode'],
    mounted() {
      console.log(this.serviceTypeCode, 'serviceTypeCode');
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('handleClose');
      },
      handleSure() {
        this.$refs['dialogForm'].validate((valid) => {
          if (valid) {
            this.dialogVisible = false;
            // this.centerDialogVisible = true;
            this.$emit('handleSure', this.dialogData.type);
          }
        });
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }
  .center {
    display: flex;
    justify-content: center;
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
